import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { UserService } from '@deltager/organizers/admin/core/services/user.service';
import { from, map } from 'rxjs';
import { take } from 'rxjs/operators';
import { AccessRole } from '@deltager/organizers/admin/shared/models/LoginData';

@Injectable({providedIn: 'root'})
export class AdminGuardService implements CanActivate {
  private _userService = inject(UserService);

  private readonly _accessRoles: AccessRole[] = [AccessRole.Administrator, AccessRole.EventAdministrator];

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    return from(this._userService.getUserData()).pipe(
      take(1),
      map(userData => this._accessRoles.includes(userData.accessRole))
    )
  }
}
